import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

type PageTitleProps = {
  title: string;
};

const PageTitle = (props: PageTitleProps) => {
  const { title } = props;
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("page_titles.document_title", { title });
  }, [location, t, title]);

  return null;
};

export default PageTitle;
